/**
 * gamesWeHave.js
 * 
 * Has the list of the games we are displaying on the website
 */

export const games = [
        {
            name: "Auction",
            status: "Available",
            description: "Bid, bluff, and build your dream lineup of anything.",
            active: true,
            slug: "auction"
        },
        {
            name: "Trust Issues",
            status: "Available",
            description: "A mind game of lies, loyalty, and sabotage.",
            active: true,
            slug: "trust-issues",
        },
        {
            name: "Life’s Unfair Tambola",
            status: "Coming Soon",
            description: "The universe plays, you suffer — coming soon.",
            active: false
        },
        {
            name: "Charades",
            status: "Coming Soon",
            description: "Act it out. Guess. Laugh. Repeat — coming soon.",
            active: false
        }
    ];